import { render, staticRenderFns } from "./PublicDishList.vue?vue&type=template&id=232d4174&"
import script from "./PublicDishList.vue?vue&type=script&lang=js&"
export * from "./PublicDishList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports